module.exports = __webpack_public_path__ + "static/scale-model-of-mill-ruins-park-in-minneapolis-minnesota-7eceee4f008d9dbe6343563c433a9d3b.png";